import { screenMdMin, spacer8 } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { useNavBarActions } from './hooks/useNavBarActions';
import { NavBarLanguageItem } from './Language';
const ActionsWrapper = styled.section `
  & ul {
    align-items: center;
    display: flex;
    gap: ${spacer8};
    list-style: none;
    margin: 0;
    padding: 0;
  }

  @media (max-width: ${screenMdMin}) {
    display: none;
  }
`;
export const NavBarActionsWithLanguage = ({ colors, language, userState, mastheadData, }) => {
    const headerEntry = mastheadData.fields.header;
    const languageSelectionEntry = mastheadData.fields
        .languageSelection;
    const { loginAction, logoutAction, claimAction, dashboardAction } = useNavBarActions({
        colors,
        container: 'header',
        userState,
        headerEntry,
    });
    return (React.createElement(ActionsWrapper, null,
        React.createElement("ul", null,
            React.createElement("li", null,
                React.createElement(NavBarLanguageItem, { colors: colors, container: "header", language: language, languageSelectionEntry: languageSelectionEntry })),
            loginAction && React.createElement("li", null, loginAction),
            logoutAction && React.createElement("li", null, logoutAction),
            claimAction && React.createElement("li", null, claimAction),
            dashboardAction && React.createElement("li", null, dashboardAction))));
};
//# sourceMappingURL=ActionsWithLanguage.js.map